module.exports = ".footer-wrapper {\n  position: absolute;\n  bottom: -155px;\n  left: 0;\n  right: 0; }\n"